import React from 'react'
import { ShowIf } from '@ztechapps/webui.util'
import { formatNumber } from '@ztechapps/common.utils'
import { Badge } from 'react-bootstrap'

export type DiscountLabelProps = {
  discountPercentage: number
}

export const DiscountLabel = ({ discountPercentage }: DiscountLabelProps) => {
  return (
    <ShowIf condition={discountPercentage > 0}>
      <div className="h4 p-0 m-0">
        <Badge pill bg="success">
          {formatNumber(discountPercentage, '#.%')} OFF
        </Badge>
      </div>
    </ShowIf>
  )
}
